import { useEffect, useState } from 'react'
import { v4 } from 'uuid'
import { Button } from 'components'
import { ReactComponent as CrossIcon } from 'assets/cross-2.svg'


export const APPENDIX = Object.freeze({
  STRENGTH: 'strength',
  ACTION: 'action',
})

const appendixLabels = {
  [APPENDIX.ACTION]: 'Action',
  [APPENDIX.STRENGTH]: 'Strength',
}

export default function Appendices({ appendices, setAppendices, title, appendixType }) {
  const [appendix, setAppendix] = useState('')
  const [active, setActive] = useState(appendices.length === 0)

  useEffect(() => {
    if (!active && appendices.length === 0) {
      setActive(true)
    }
  }, [appendices, setActive])

  const submitAppendix = () => {
    if (appendix) {
      const newAppendix = { id: v4(), action: 'add', name: appendixType, value: appendix }
      setAppendices([...appendices, newAppendix])
      setAppendix('')
      setActive(false)
    }
  }

  const removeAppendix = (index) => {
    const appendixToBeRemoved =  {...appendices[index], action: 'remove' }
    const newAppendices = [appendixToBeRemoved, ...appendices.slice(0, index), ...appendices.slice(index + 1)]
    setAppendices(newAppendices)
  }

  return (
    <div className='actions'>
      <h4>{title}</h4>
      <div className='actions-list'>
      {appendices.map(
        ({ action, value }, id) =>
          action !== 'remove' && (
            <div className='display-row' key={id}>
              <div style={{whiteSpace: 'pre-line'}}>
                {value}
              </div>
              <div style={{
                position: 'absolute',
                 top: '8px',
                 right: '4px',
              }}>
                  <CrossIcon className='close-icon'
                  onClick={() => {
                    removeAppendix(id)
                  }}/>
              </div>
            </div>
          )
      )}
      </div>
    {
      active && (
      <div className='action-row'>
        <textarea
          id='action-input'
          rows={4}
          maxLength={2000}
          value={appendix}
          onChange={({ target: { value } }) => setAppendix(value)}
          autoFocus
        />
        <div className='button-row'>
          <Button label='Save' onClick={() => submitAppendix()}/>
          <Button label='Cancel' type='secondary' onClick={() => { 
            setAppendix('')
            setActive(false)
          }}/>
        </div>
      </div>
      )
    }
    { !active && (
      <div style={ {marginTop: '8px' }}>
        <Button label={`Add ${appendixLabels[appendixType]}`} onClick={() => setActive(true)}/>
      </div>
    )}
    </div>
  )
}
